// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"10d1d90e","453":"71f04c88"}[chunkId] + ".chunk.js";
};